<mat-slide-toggle (change)="valueChanged($event)" (click)="toggleClicked($event)" [checked]="isChecked()" [disabled]="isEditable()" aria-label="slide" ></mat-slide-toggle>
